export default __webpack_public_path__ + "static/media/2.7e8b61c5.jpg";